<template>
  <el-dialog
    class="auxiliary-popup"
    :class="device.isMobile ? 'auxiliary-popup-mobile' : ''"
    :title="dialogTitle"
    :visible.sync="visible"
    :destroy-on-close="true"
    :append-to-body="true"
    @close="closeHandle"
    style="z-index: 10000"
    v-if="visible"
  >
    <div class="auxiliary-box">
      <div class="auxiliary-list">
        <template >
          <div
            class="auxiliary-item"
            v-for="(item, index) in content.content"
            :key="item.key"
            v-show="activeIndex === index"
          >
            <div class="item-title">{{ item.title }}</div>
            <div class="item-info">{{ item.info }}</div>
            <div class="item-images" :style="{'background': item.images.length > 0 ? 'transparent' : ''}">
              <div v-for="(img, idx) in item.images" class="image-box" :key="idx">
                <el-image class="image" :src="img" :preview-src-list="[img]"></el-image>
              </div>
            </div>
          </div>
        </template>
      </div>
      <div class="auxiliary-bottom">
        <span
          class="pre-btn bottom-btn"
          @click.stop="backClick()"
          :class="activeIndex === 0 ? 'backDisabled' : ''"
          >上一项</span
        ><span
          class="next-btn bottom-btn"
          @click.stop="nextClick()"
          :class="activeIndex == content.content.length - 1 ? 'backDisabled' : ''"
          >下一项</span
        >
      </div>
    </div>
  </el-dialog>
</template>

<script>
/*
辅助工具弹窗
*/
export default {
  name: "auxiliaryPopup",
  props: {
    dialogTitle: {
      type: String,
      default: ""
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dialogType: {
      type: String,
      default: ""
    },
    content: {
      type: Object,
      default: () => {
        return {};
      }
    },
  },
  watch: {
    dialogVisible(newVal) {
      this.visible = newVal
    }
  },
  data() {
    return {
      visible: false,
      activeIndex: 0,
    }
  },
  methods: {
    // 下一项
    nextClick() {
      if(this.activeIndex === this.content.content.length - 1) {
        return false;
      }
      this.activeIndex += 1;
    },
    // 前一项
    backClick() {
      if(this.activeIndex === 0) {
        return false;
      }
      this.activeIndex -= 1;
    },
    closeHandle() {
      this.$emit('dialogClose')
    },
  }
}
</script>

<style lang="scss" scoped>
.auxiliary-popup{
  text-indent: 0;

  .auxiliary-box{
    height: 100%;
    width: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    padding-bottom: 80rem;
    position: absolute;

    .auxiliary-list{
      flex: 1;
      overflow: hidden;

      .auxiliary-item{
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        padding: 0 24rem;

        .item-title{
          font-size: 20rem;
          color: #333;
          font-weight: bold;
          margin-top: 20rem;
        }

        .item-info{
          font-size: 16rem;
          color: #666;
          margin-top: 8rem;
        }

        .item-images{
          flex: 1;
          background: #E0E0E0;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 15rem 0;

          .image-box{
            min-height: 240rem;
            max-height: 300rem;
            max-width: 90%;

            .image{
              display: block;
              height: 100%;
              width: auto;
              box-shadow: 0px 10px 30px 0px rgba(83,107,130,0.3);
            }

            &:nth-child(2) {
              margin-left: 30rem;
            }
          }
        }
      
        &:last-child{
          .item-images{
            .image-box{
              height: 240rem;
              /deep/.el-image__inner{
                width: auto;
              }
            }
          }
        }
      }
    }
    .auxiliary-bottom {
      position: fixed;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 70rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 5rem 50rem;
      background: #fff;
      border-top: 1rem solid #E3E3E3;
  
      span {
        width: 154rem;
        height: 48rem;
        line-height: 48rem;
        display: inline-block;
        text-align: center;
        font-size: 19rem;
        cursor: pointer;
      }
  
      .next-btn {
        margin-left: 12rem;
      }
      
      .bottom-btn{
        border: 0;
        font-size: 16rem;
        height: 40rem;
        line-height: 40rem;
        color: #333;
      }
      
      .backDisabled {
        opacity: 0.5;
        color: #999;
        pointer-events: auto !important;
        cursor: not-allowed !important;
      }
    }
  }
}
/deep/.el-dialog {
  width: 750rem;
  margin: 0;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 10rem 10rem 0rem 0rem;
  min-height: 60%;
  max-height: 90%;
  display: flex;
  flex-direction: column;

  .el-dialog__header{
    flex: 0 0 72rem;
    border-bottom: 2rem solid #E3E3E3;
    padding: 20rem 30rem 10rem;
    .el-dialog__title{
      font-size: 20rem;
      line-height: 40rem;
      color: #333;
    }
    .el-dialog__headerbtn{
      top: 30rem;
      right: 30rem;
    }
  }
  
  .el-dialog__body{
    flex: 1;
    padding: 0;
    position: relative;
  }
}

.auxiliary-popup-mobile{
  
  .auxiliary-box{
    padding-bottom: 180rem;
    .auxiliary-list{
      .auxiliary-item{
        .item-title{
          font-size: 30rem;
          line-height: 50rem;
        }
        .item-info{
          font-size: 28rem;
          margin-top: 8rem;
        }
        .item-images{
          .image-box{
            max-height: 400rem;
          }
        }
        
        &:last-child{
          .item-images{
            .image-box{
              height: 400rem;
            }
          }
        }
      }
    }

    .auxiliary-bottom {
      flex: 0 0 177rem;
      height: 177rem;
      padding: 40rem 24rem 0;
      border-top: 1rem solid #E3E3E3;
      align-items: start;
  
      span {
        width: 154rem;
        height: 78rem;
        line-height: 78rem;
        font-size: 28rem;
      }
  
      .next-btn {
        margin-left: 12rem;
      }
      
      .bottom-btn{
        font-size: 28rem;
        height: 78rem;
        line-height: 78rem;
      }
    }
  }

  /deep/.el-dialog{
    .el-dialog__header{
      border-bottom: 2rem solid #E3E3E3;
      padding: 30rem 26rem;
      .el-dialog__title{
        font-size: 36rem;
        line-height: 48rem;
      }
      .el-dialog__headerbtn{
        font-size: 40rem;
        top: 30rem;
        right: 30rem;
      }
    }
    .el-dialog__body{
      padding: 0;
    }
  }
}
</style>